/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const getPathFromWebsiteURL = (url: string): string => {
  try {
    const urlObject = new URL(url);
    return urlObject.pathname;
  } catch {
    return '';
  }
};
